<div class="wrapper">
    <sew-icon class="svg" icon="search"></sew-icon>
    <div class="input-wrapper">
        <input
            #searchQuery
            class="text"
            name="q"
            placeholder="{{ placeholder }}"
            type="text"
            pattern=".{1,}"
            autocomplete="off"
            (keyup)="onKeyUp($event)"
            list="autocomp"
        />
    </div>
    @if (query.length) {
        <div class="close-wrapper" (click)="onCloseSearch()">
            <button class="container">
                <span class="icons-close-reg"></span>
            </button>
        </div>
    }
</div>
